import PropTypes from 'prop-types';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import { jsx as _jsx } from "react/jsx-runtime";
const StaticBranchActionHistoryCard = ({
  actionLabel
}) => {
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel
  });
};
export default StaticBranchActionHistoryCard;
StaticBranchActionHistoryCard.propTypes = {
  actionLabel: PropTypes.node
};